<template>
    <div class="modal-wrapper" @click="closeTheModal">
      <div class="modal-container" @click.stop>
        <div class="modal-btn-close" @click="closeTheModal">
            <!-- close button using material icons -->
            <span class="material-symbols-outlined close-icon em2">cancel</span>
        </div>
        <div class="modal-signup-header">
          <h1>Never Miss a Deal Again!</h1>
          <p class="subheading">Get alerts for 🔥 price drops, new coupons, and trending deals.</p>
        </div>
        <div class="modal-signup-body">
          <ul class="benefits">
            <li>🛍️ Hand-picked deals from your favorite stores</li>
            <li>⏰ Early access to lightning deals</li>
            <li>📬 No spam, just pure savings</li>
          </ul>
        </div>
        <div class="whatsapp-icon">
            <img :src="`/assets/img/logo-whatsapp.png`" />
        </div>
        <div class="modal-signup-body">We use <strong>Whatsapp</strong> to send you deal alerts. You can opt out anytime.</div>
        <div class="modal-signup-footer">
          <a class="subscribe-btn" href="/JoinWhatsapp" target="_blank" @click="joinWhatsapp()">🔔 Get Alerts</a>
          
        </div>
        <div class="modal-cancel-anytime"><p class="footnote">Totally free. Opt out anytime.</p></div>
      </div>
    </div>
  </template>

<script setup lang="ts">
import ga from "@/helpers/ga";
import clicky from "@/helpers/clicky";
import { globalStore } from '@/stores/globalStore'

const $globalStore = globalStore()
const closeTheModal = () => {
    $globalStore.setShowModalDealAlerts(false)
}

const joinWhatsapp = () => {
  ga.event("click", {
    event_category: "whatsapp",
    event_label: "whatsapp",
    transport_type: "beacon",
  });
  clicky.goal("JoinWhatsAlertsModal");
};
</script>

<style scoped>
.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000000;
}

.modal-container {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 400px;
  padding: 2rem;
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
  text-align: center;
  animation: popIn 0.3s ease-out;
}

@keyframes popIn {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.modal-signup-header h1 {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #ff3c6f;
}

.subheading {
  font-size: 1rem;
  color: #444;
  margin-bottom: 1.2rem;
}

.benefits {
  text-align: left;
  list-style: none;
  padding-left: 0;
  margin-bottom: 1.5rem;
}

.benefits li {
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
  color: #333;
}

.subscribe-btn {
  background: linear-gradient(to right, #ff416c, #ff4b2b);
  color: white;
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 50px;
  font-size: 1.25rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(255, 72, 112, 0.4);
  transition: transform 0.2s ease;
}

.subscribe-btn:hover {
  transform: scale(1.05);
}

.footnote {
  font-size: 0.75rem;
  color: #777;
  margin-top: 0.8rem;
}

.whatsapp-icon img {
  width: 60px;
  height: 60px;
  margin: 0 auto;
  margin-bottom: 10px;
}

.modal-signup-footer {
    margin-top: 1.5rem;
}

.modal-cancel-anytime {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
}



</style>